import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25ba0b0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aside-navigator__bottom" }

import { ref, computed, onUnmounted, onMounted } from 'vue'
import { useLocalStorage, useMouse, useTimeoutFn } from '@vueuse/core'
import Icon from '@teams/common/components/icon'
import { VerticalNavs } from '@/components/navigator'
import { useGroupStore } from '@/store/group'
import { useUserStore } from '@/store/user'
import { useDrawer } from '@/components/drawer'
import useNav from '@/components/navigator/useNav'
import useMitt from '@/hooks/useMitt'
import { events } from '@/constants'
import AsideDrawer from './asideDrawer.vue'
import { DrawerProps } from 'naive-ui'
import useViewConfig from '@/hooks/useViewConfig'


export default /*#__PURE__*/_defineComponent({
  __name: 'aside',
  setup(__props) {

_useCssVars(_ctx => ({
  "56ff338a": (asideNavigatorWidthStyle.value)
}))

const emitter = useMitt()
const { x } = useMouse({ touch: false })
const { showNavBarOptions, contextMenuVisible } = useNav()
const { shouldStickyGroupPanel } = useViewConfig()
const groupStore = useGroupStore()
const userStore = useUserStore()
const drawer = useDrawer()
const presetCollapseWidth = 48
const presetExpandWidth = 240
const minNavigatorBoxWidth = 240
const maxNavigatorBoxWidth = 440
const dragging = ref(false)
const routerViewEle = ref<HTMLElement>()
const {
  isPending,
  start: closeDrawer,
  stop: stopCloseDrawer
} = useTimeoutFn(() => {
  if (!contextMenuVisible.value && drawer.visible.value) {
    drawer.closeByDrawerKey('AsideDrawer')
  }
}, 250)

const asideWidthStorage = useLocalStorage(
  `${groupStore.groupId}:${userStore.userId}:asideNavigatorWidth`,
  presetExpandWidth
)

// 在收起状态时，hover 上去则切换至临时展开状态，该状态下不能拖拽宽度
const asideExpanding = computed(
  () => asideWidthStorage.value > presetCollapseWidth
)
const asideNavigatorWidthStyle = ref(`${asideWidthStorage.value}px`)

const startDragging = (e: MouseEvent) => {
  dragging.value = true
  const startX = e.clientX
  const initWidth = asideWidthStorage.value

  const onDragging = (e: MouseEvent) => {
    if (dragging.value) {
      emitter.emit(events.canMove, true)
      const currentX = e.clientX
      const offsetX = currentX - startX
      asideWidthStorage.value = Math.min(
        Math.max(initWidth + offsetX, minNavigatorBoxWidth),
        maxNavigatorBoxWidth
      )
      asideNavigatorWidthStyle.value = `${asideWidthStorage.value}px`
    }
  }

  const stopDragging = () => {
    dragging.value = false
    emitter.emit(events.canMove, false)
    document.removeEventListener('mousemove', onDragging)
    document.removeEventListener('mouseup', stopDragging)
  }

  document.addEventListener('mousemove', onDragging)
  document.addEventListener('mouseup', stopDragging)
}

const toggleCollapseAsideNav = () => {
  asideWidthStorage.value = asideExpanding.value
    ? presetCollapseWidth
    : presetExpandWidth
  asideNavigatorWidthStyle.value = `${asideWidthStorage.value}px`
}

const onAsideMouseEnter = () => {
  if (!asideExpanding.value) {
    let drawerProps: Partial<DrawerProps> = {
      placement: 'left',
      width: presetExpandWidth,
      to: '#view-home-body',
      showMask: 'transparent',
      onAfterEnter() {
        if (
          x.value >
          minNavigatorBoxWidth + (shouldStickyGroupPanel.value ? 300 : 0)
        ) {
          drawer.closeByDrawerKey('AsideDrawer')
        }
      }
    }
    if (contextMenuVisible.value) {
      drawerProps = { ...drawerProps, zIndex: 2000 }
    }
    drawer.show({
      drawerProps,
      component: AsideDrawer,
      componentKey: 'AsideDrawer',
      componentProps: {
        expanding: true,
        toggleExpanding: () => {
          drawer.close()
          toggleCollapseAsideNav()
        },
        onMouseLeave: closeDrawer
      },
      className: 'expandingNav__ClassName'
    })
  }
}

const closeDrawerEvent = () => {
  closeDrawer()
}

const cancelCloseDrawerEvent = () => {
  // 优化体验，快速移出浏览器外部在移入则取消关闭
  if (
    x.value <
    minNavigatorBoxWidth + (shouldStickyGroupPanel.value ? 300 : 0)
  ) {
    isPending && stopCloseDrawer()
  }
}

onMounted(() => {
  routerViewEle.value = window.document.querySelector(
    '.route-container__right'
  ) as HTMLElement
  if (routerViewEle.value) {
    routerViewEle.value.addEventListener('mouseleave', closeDrawerEvent)
    routerViewEle.value.addEventListener('mouseenter', cancelCloseDrawerEvent)
  }
})
onUnmounted(() => {
  if (routerViewEle.value) {
    routerViewEle.value.removeEventListener('mouseleave', closeDrawerEvent)
    routerViewEle.value.removeEventListener(
      'mouseenter',
      cancelCloseDrawerEvent
    )
  }
})

return (_ctx: any,_cache: any) => {
  const _component_n_scrollbar = _resolveComponent("n-scrollbar")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'aside-navigator',
      { 'aside-navigator__dragging': dragging.value },
      { 'aside-navigator__position': !_unref(asideExpanding) }
    ]),
    onMouseenter: onAsideMouseEnter,
    onContextmenu: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(showNavBarOptions) && _unref(showNavBarOptions)(...args)), ["prevent","stop"]))
  }, [
    (_unref(asideExpanding))
      ? (_openBlock(), _createBlock(_component_n_scrollbar, {
          key: 0,
          style: _normalizeStyle({
        flex: 1,
        paddingRight: _unref(asideExpanding) ? '12px' : 0
      })
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(VerticalNavs))
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(['bottom-icon', { 'bottom-icon__collapse': !_unref(asideExpanding) }]),
        onClick: toggleCollapseAsideNav
      }, [
        _createVNode(_component_n_tooltip, {
          trigger: "hover",
          placement: "right"
        }, {
          trigger: _withCtx(() => [
            _createVNode(_unref(Icon), {
              name: "packUp1",
              fill: "transparent",
              stroke: "#161819"
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(asideExpanding) ? '收起导航栏' : '展开导航栏'), 1)
          ]),
          _: 1
        })
      ], 2)
    ]),
    _createElementVNode("div", {
      class: "aside-navigator__right",
      onMousedown: startDragging
    }, null, 32)
  ], 34))
}
}

})